import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  Upload,
  Button,
  Space,
  InputNumber,
  Card,
  DatePicker,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import {
  UploadOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function UploadTest() {
  const [form] = Form.useForm();
  const [disableForm, setDisableForm] = useState(false);
  const navigate = useNavigate();
  const [testTypesResponse, getTestTypes] = useApi(
    `/admin/test-types/dropdown`,
    null,
    API_METHODS.GET
  );
  const [getMonthsResponse, getMonthsRequest] = useApi(
    `/admin/general/get-months`,
    null,
    API_METHODS.GET
  );

  const [getWeeksResponse, getWeeksRequest] = useApi(
    `/admin/general/get-weeks`,
    null,
    API_METHODS.GET
  );

  const [subscriptionTypesResponse, getSubscriptionTypes] = useApi(
    `/admin/video/subscription-type-dropdown`,
    null,
    API_METHODS.GET
  );

  const [uploadTestResponse, uploadTestRequest] = useApi(
    `/admin/test/upload`,
    null,
    API_METHODS.POST,
    true // for multipart data
  );

  const [testTypes, setTestTypes] = useState([]);
  const [months, setMonths] = useState([]);
  const [weeks, setWeeks] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [selectedTestType, setSelectedTestType] = useState();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getTestTypes();
    getMonthsRequest();
    getWeeksRequest();
    getSubscriptionTypes();
  }, []);

  useEffect(() => {
    const data =
      testTypesResponse.data !== BLANK_VALUE ? testTypesResponse.data : [];
    setTestTypes(data);
  }, [testTypesResponse]);

  useEffect(() => {
    const data =
      getMonthsResponse.data !== BLANK_VALUE ? getMonthsResponse.data : [];
    setMonths(data);
  }, [getMonthsResponse]);

  useEffect(() => {
    const data =
      getWeeksResponse.data !== BLANK_VALUE ? getWeeksResponse.data : [];
    setWeeks(data);
  }, [getWeeksResponse]);

  useEffect(() => {
    const data =
      subscriptionTypesResponse.data !== BLANK_VALUE
        ? subscriptionTypesResponse.data
        : [];
    setSubscriptionTypes(data);
  }, [subscriptionTypesResponse]);

  useEffect(() => {
    if (uploadTestResponse.data) {
      setDisableForm(false);
      messageApi.open({
        type: "success",
        content: "Test added successfully",
      });
      navigate("/portal/tests");
    } else if (uploadTestResponse.error) {
      setDisableForm(false);
      messageApi.open({
        type: "error",
        content: uploadTestResponse.error,
      });
      navigate("/portal/tests");
    }
  }, [uploadTestResponse]);

  const uploadProps = {
    beforeUpload: (file) => {
      //   const isImage = file.type === "image/png" || file.type === "image/jpeg";
      //   if (!isImage) {
      //     message.error(`${file.name} error. Only PNG and JPEG files supported`);
      //   }
      //   return isImage || Upload.LIST_IGNORE;
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const testTypeSelected = (type) => {
    setSelectedTestType(type);
  };

  const onFinish = (values) => {
    setDisableForm(true);
    const formData = new FormData();
    for (const name in values) {
      if (name === "file") {
        if (values["file"] !== undefined) {
          formData.append(
            "test",
            values["file"].file.originFileObj,
            values["file"].file.name
          );
        }
      } else if (name === "sections") {
        // Handle array of section objects
        values[name].forEach((sectionObject) => {
          formData.append(
            "sections[]",
            JSON.stringify({
              section_name: sectionObject.section_name,
              section_time: sectionObject.section_time,
              section_order: sectionObject.section_order,
            })
          );
          // Optional: If the file property exists within each section object:
          if (sectionObject.file !== undefined) {
            formData.append(
              `${sectionObject.section_order}`,
              sectionObject.file.file.originFileObj,
              sectionObject.file.file.name
            );
            // This appends a file entry with a key based on section_name for better organization on the server-side.
          }
        });
      } else {
        formData.append(name, values[name]);
      }
    }

    uploadTestRequest(formData);
  };

  return (
    <Card title="Upload Test">
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        initialValues={{
          sections: [{}],
          is_free: 0,
        }}
        disabled={disableForm}
      >
        {contextHolder}
        {testTypes?.length > 0 && (
          <>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Name is required." }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="type_id"
                  label="Test Type"
                  rules={[
                    { required: true, message: "Test Type is required." },
                  ]}
                >
                  <Select
                    placeholder="Select Test Type"
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onSelect={testTypeSelected}
                  >
                    {testTypes.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.type}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {selectedTestType && selectedTestType !== 4 && (
                <Col span={8}>
                  <Form.Item
                    name="subscription_id"
                    label="Subscription"
                    rules={[
                      {
                        required: true,
                        message: "Subscription Type is required.",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Subscription Type"
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {subscriptionTypes.map((option) => (
                        <Select.Option key={option.id} value={option.id}>
                          {option.subscription_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item
                  name="is_free"
                  label="Is Free Test"
                  rules={[
                    {
                      required: true,
                      message: "Is Free Test is required.",
                    },
                  ]}
                >
                  <Select
                    options={[
                      {
                        value: 1,
                        label: "Yes",
                      },
                      {
                        value: 0,
                        label: "No",
                      },
                    ]}
                    disabled={selectedTestType != 3}
                  />
                </Form.Item>
              </Col>
              {selectedTestType && selectedTestType === 1 && (
                <Col span={8}>
                  <Form.Item
                    name="week"
                    label="Week"
                    rules={[{ required: true, message: "Week is required." }]}
                  >
                    <Select placeholder="Select Week" allowClear showSearch>
                      {weeks.map((option) => (
                        <Select.Option key={option.id} value={option.id}>
                          {option.week}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              {selectedTestType &&
                (selectedTestType == 1 || selectedTestType == 2) && (
                  <Col span={8}>
                    <Form.Item
                      name="month"
                      label="Month"
                      rules={[
                        { required: true, message: "Month is required." },
                      ]}
                    >
                      <Select
                        placeholder="Select Month"
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {months.map((option) => (
                          <Select.Option key={option.id} value={option.id}>
                            {option.month}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
              {selectedTestType && selectedTestType == 4 && (
                <Col span={8}>
                  <Form.Item
                    name="date"
                    label="Date"
                    rules={[{ required: true, message: "Date is required." }]}
                  >
                    <DatePicker />
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item
                  name="description"
                  label="Description"
                  rules={[
                    { required: true, message: "Description is required." },
                  ]}
                >
                  <Input.TextArea />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="total_time"
                  label="Total Time"
                  rules={[
                    { required: true, message: "Total Time is required." },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              {selectedTestType && selectedTestType !== 3 && (
                <Col span={24}>
                  <Form.Item
                    name="file"
                    label="Upload Test"
                    rules={[{ required: true, message: "File is required." }]}
                  >
                    <Upload.Dragger
                      customRequest={dummyRequest}
                      {...uploadProps}
                      maxCount={1}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Click or drag file to this area to upload
                      </p>
                    </Upload.Dragger>
                  </Form.Item>
                </Col>
              )}
              {selectedTestType && selectedTestType == 3 && (
                <Col span={8}>
                  <Form.Item
                    name="mock_test_number"
                    label="Mock Test Number"
                    rules={[
                      {
                        required: true,
                        message: "Mock Test Number is required.",
                      },
                    ]}
                  >
                    <InputNumber />
                  </Form.Item>
                </Col>
              )}
            </Row>
            {selectedTestType && selectedTestType == 3 && (
              <Form.List name="sections">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: "flex",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "section_name"]}
                          label="Section Name"
                          rules={[
                            {
                              required: true,
                              message: "Missing section name",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, "section_time"]}
                          label="Section Time"
                          rules={[
                            {
                              required: true,
                              message: "Missing Section Time",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "section_order"]}
                          label="Section Order"
                          rules={[
                            {
                              required: true,
                              message: "Missing section name",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          name={[name, "file"]}
                          label="Upload Section"
                          rules={[
                            { required: true, message: "File is required." },
                          ]}
                        >
                          <Upload
                            customRequest={dummyRequest}
                            {...uploadProps}
                            maxCount={1}
                          >
                            <Button icon={<UploadOutlined />}>
                              Click to Upload
                            </Button>
                          </Upload>
                        </Form.Item>

                        {fields.length > 1 && (
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        )}
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add section
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            )}
            <Form.Item style={{ float: "right" }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </>
        )}
      </Form>
    </Card>
  );
}

export default UploadTest;
